module.exports = __webpack_public_path__ + "img/Banner-04.3e71bdb8.png";